import { IHttpApi } from '@cian/http-api';
import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesResponse,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';
import { ResponseError } from '../../utils/errors';

export interface IRemoveNewbuildingFromFavoritesParameters {
  /** ID ЖК **/
  newbuildingId: number;
}

export async function removeNewbuildingFromFavorites(
  httpApi: IHttpApi,
  parameters: IRemoveNewbuildingFromFavoritesParameters,
) {
  const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
    httpApi,
    parameters: { entityId: parameters.newbuildingId, dealType: 'sale', entityType: 'newbuilding' },
  });

  if (response.statusCode !== 200) {
    const { errors, message } = response.response;

    throw new ResponseError({
      domain: 'shared/services/removeNewbuildingFromFavorites',
      message: 'Failed removing newbuilding from favorites',
      details: { errors: JSON.stringify(errors), message },
    });
  }

  return response.response;
}
